import { useMutation } from '@tanstack/react-query';
import { OAuthFlowsApi, type OAuthProvider } from 'osep-auth-service-client-v1';
import { useApiConfig } from '../useApiConfig';

export const useStartOAuthFlowMutation = () => {
  const { getAuthApiConfig, axiosInstance } = useApiConfig();

  return useMutation({
    mutationFn: async (type: OAuthProvider) => {
      const api = new OAuthFlowsApi(
        await getAuthApiConfig(),
        undefined,
        axiosInstance,
      );
      const returnUrl = `${window.location.origin}${window.location.pathname}${window.location.search}`;
      const response = await api.createOauthFlow(
        { type, returnUrl },
        undefined,
        {
          withCredentials: true,
        },
      );
      return response.data;
    },
    onSuccess: ({ authorizeUrl }) => {
      window.location.href = authorizeUrl;
    },
  });
};
